import { render } from "./supply.vue?vue&type=template&id=39a06a76&scoped=true"
import script from "./supply.vue?vue&type=script&lang=js"
export * from "./supply.vue?vue&type=script&lang=js"

import "./supply.vue?vue&type=style&index=0&id=39a06a76&scoped=true&lang=css"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a06a76"]])

export default __exports__